export default __webpack_public_path__ + "static/media/sm.09f27119.svg";